import { planningResourcesFtaFactSheetsCircularsComponent } from './planning-resources-fta-fact-sheets-circulars.component';
import { FtaFactSheetsCircularsService } from './planning-resources-fta-fact-sheets-circulars.service';

export const planningResourcesFtaFactSheetsCirculars = angular
     .module('components.planningResourcesFtaFactSheetsCirculars', [])
     .component('planningResourcesFtaFactSheetsCirculars', planningResourcesFtaFactSheetsCircularsComponent)
     .service('FtaFactSheetsCircularsService', FtaFactSheetsCircularsService)
     .name;


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-fta-fact-sheets-circulars/planning-resources-fta-fact-sheets-circulars.module.js